import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from "@angular/router";
import { SharedService } from "./../../../shared/shared.service";
import { AdminDevoteeService } from './../../services/admin-devotee.service';
import { DevoteeDetail } from "./../../../devotee/devotee-detail";


@Component({
  selector: 'app-add-devotee',
  templateUrl: './add-devotee.component.html',
  styleUrls: ['./add-devotee.component.css'],
  providers: [AdminDevoteeService]
})
export class AddDevoteeComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private adminDevoteeService: AdminDevoteeService,
    private sharedService: SharedService,
    private activeRoute: ActivatedRoute
  ) { }

  devoteeForm: FormGroup;
  devoteeId: number;
  stateList: string[] = [];
  devoteeAddressList: DevoteeDetail[] = [];
  duplicateDevoteeListMsg: string = "";
  savedMessage: string = "";
  errorMessage: string = "";
  duplicateDevMsg: string = "";
  duplicateDevMsgCss: string = "";
  isVIPDevotee: boolean = false;

  ngOnInit() {

    this.activeRoute.params.subscribe(params => this.devoteeId = params.id)

    this.createDevoteeForm();
    this.stateList = this.sharedService.StateLists;
  }

  createDevoteeForm() {

    this.createAddDevoteeForm();
    if (this.devoteeId == undefined) {
      this.createAddDevoteeForm();
      return;
    }

    this.sharedService.showSpinner();
    this.adminDevoteeService.searchDevotee({ devoteeId: this.devoteeId }).subscribe(
      data => this.createEditDevoteeForm(data.PageData[0]),
      err => this.errorMessage = err,
      () => this.sharedService.hideSpinner()
    )
  }

  checkDuplicate() {
    if (this.devoteeForm.controls.MobileNo.invalid) {
      this.devoteeForm.controls.MobileNo.markAsTouched({ onlySelf: true });
      return;
    }

    let mobileNo = this.devoteeForm.controls.MobileNo.value;

    this.sharedService.showSpinner();
    this.adminDevoteeService.getByMobileNo(mobileNo).subscribe(
      data => this.setDuplicateDevoteeMessage(data.PageData),
      err => console.log(err),
      () => this.sharedService.hideSpinner()
    );
  }


  setDuplicateDevoteeMessage(devoteeDetails: DevoteeDetail[]): void {
    console.log(devoteeDetails);
    if (devoteeDetails && devoteeDetails.length > 0) {
      let devoteeDetail = devoteeDetails[0];

      this.duplicateDevMsg = `This mobile number ${devoteeDetail.MobileNo} is already register with
                                  Devotee ${devoteeDetail.FirstName} ${devoteeDetail.MiddleName} ${devoteeDetail.LastName}`;
      this.duplicateDevMsgCss = "text-danger"
      return;

    }

    this.duplicateDevMsg = "This mobile number is not register";
    this.duplicateDevMsgCss = "text-success"
    return;
  }

  changeVIPStatus() {
    this.isVIPDevotee = !this.isVIPDevotee;
    console.log(this.isVIPDevotee);
  }




  saveForm(): void {

    let devoteeDetail: any = { ...this.devoteeForm.value };
    devoteeDetail.IsVIPDevotee = this.isVIPDevotee;
    devoteeDetail.PinCode = devoteeDetail.PinCode.toString();
    devoteeDetail.MobileNo = devoteeDetail.MobileNo.toString();
    devoteeDetail.AlternetMobileNo1 = devoteeDetail.AlternetMobileNo1 ? devoteeDetail.AlternetMobileNo1.toString() : "";
    devoteeDetail.AlternetMobileNo2 = devoteeDetail.AlternetMobileNo2 ? devoteeDetail.AlternetMobileNo2.toString() : "";

    if (this.devoteeForm.invalid) {
      this.sharedService.validateAllFormFields(this.devoteeForm);
      return;
    }

    // Save Devotee
    console.log(devoteeDetail);
    if (devoteeDetail.Id) {
      this.sharedService.showSpinner();
      this.adminDevoteeService.updateDevotee(devoteeDetail).subscribe(
        data => {
          this.resetForm();
          this.savedMessage = "Data updated successfully";
          console.log(data);
        },
        err => {
          this.errorMessage = err.error.Message;
          console.log(this.errorMessage);
          this.sharedService.hideSpinner();
        },
        () => this.sharedService.hideSpinner()
      )
    }
    else {
      this.sharedService.showSpinner();
      this.adminDevoteeService.saveDevotee(devoteeDetail).subscribe(
        data => {
          this.resetForm();
          this.savedMessage = "data saved successfully";
          console.log(data);
        },
        err => {
          this.errorMessage = err.error.Message;
          console.log(this.errorMessage);
          this.sharedService.hideSpinner();
        },
        () => this.sharedService.hideSpinner()
      )
    }
  }

  loadDevoteeList() {

    let firstName = this.devoteeForm.controls.FirstName.value;
    let lastName = this.devoteeForm.controls.LastName.value;

    if (!(firstName && lastName)) {
      return;
    }

    let searchEntity = {
      FirstName: firstName,
      LastName: lastName,
      PageNumber: 1
    }

    this.duplicateDevoteeListMsg = "Checking Duplicate Names....";
    this.devoteeAddressList = [];
    this.adminDevoteeService.searchDevotee(searchEntity).subscribe(
      data => {
        console.log(data);
        this.devoteeAddressList = data.PageData;
      },
      err => this.errorMessage = err,
      () => {
        this.duplicateDevoteeListMsg = this.devoteeAddressList.length ? "Below is the duplicate records" : "There is no Duplicate Name";
      }
    )
  }

  resetForm(): void {
    this.devoteeForm.reset();
    this.devoteeForm.controls.Id.setValue(0);
    this.isVIPDevotee = false;
    this.savedMessage = "";
    this.errorMessage = "";
  }

  createAddDevoteeForm(): void {
    this.devoteeForm = this.formBuilder.group({
      Id: [0],
      FirstName: ["", Validators.required],
      MiddleName: [""],
      LastName: ["", Validators.required],
      AddressLine1: [, Validators.maxLength(28)],
      AddressLine2: [, Validators.maxLength(28)],
      AddressLine3: [, Validators.maxLength(28)],
      AddressLine4: [, Validators.maxLength(28)],
      City: [, Validators.required],
      State: ["", Validators.required],
      PinCode: [, [Validators.required, Validators.maxLength(6)]],
      MobileNo: [, Validators.required],
      AlternetMobileNo1: [],
      AlternetMobileNo2: [],
      Email: [],
      OldMobileNo: []
    });
  }

  createEditDevoteeForm(devoteeDetail: DevoteeDetail): void {
    this.isVIPDevotee = devoteeDetail.IsVIPDevotee;

    this.devoteeForm = this.formBuilder.group({
      Id: [devoteeDetail.Id],
      FirstName: [devoteeDetail.FirstName, Validators.required],
      MiddleName: [devoteeDetail.MiddleName],
      LastName: [devoteeDetail.LastName, Validators.required],
      AddressLine1: [devoteeDetail.AddressLine1, Validators.maxLength(28)],
      AddressLine2: [devoteeDetail.AddressLine2, Validators.maxLength(28)],
      AddressLine3: [devoteeDetail.AddressLine3, Validators.maxLength(28)],
      AddressLine4: [devoteeDetail.AddressLine4, Validators.maxLength(28)],
      City: [devoteeDetail.City, Validators.required],
      State: [devoteeDetail.State, Validators.required],
      PinCode: [devoteeDetail.PinCode, [Validators.required, Validators.maxLength(6)]],
      MobileNo: [devoteeDetail.MobileNo, Validators.required],
      AlternetMobileNo1: [devoteeDetail.AlternetMobileNo1],
      AlternetMobileNo2: [devoteeDetail.AlternetMobileNo2],
      Email: [devoteeDetail.Email],
      OldMobileNo: [devoteeDetail.MobileNo]
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/add-devotee/add-devotee.component.ts